import Analysis from 'domain/entity/analysis';
import { getApiClient } from 'adapter/out/client/apiClient';
import SaveToDashboardCriteria from 'use-case/analysis/saveToDashboard/saveToDashboardCriteria';

const sendToDashboardApiClient = getApiClient(
    (clientCriteria: SaveToDashboardCriteria) => `dashboards/analyses/${clientCriteria.analysisId}/save-as-dashboard-analysis`,
    Analysis,
    (clientCriteria: SaveToDashboardCriteria) => ({
        method: 'POST',
        body: JSON.stringify({
            dashboard_id: clientCriteria.dashboardId,
            period: clientCriteria.period,
        }),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default sendToDashboardApiClient;
